module.exports = __webpack_public_path__ + "img/arepa_carne_desmechada.fe9d411e.jpeg";